import { useTranslation } from "react-i18next";
import { useAuthContext } from "components/context/authContext";
import AuthActionBtn from "./authAction.tsx/index.tsx";
import LangChange from "./langChange.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import { alertControl, modalControl } from "util/commAction.ts";
import LoginModal from "components/modal/login/index.tsx";
import "../header.scss";

type IProps = {};

export default function WebHeader() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { lodInf } = useAuthContext();
  const { t } = useTranslation<"translation">();
  const { isLogin } = useAuthContext();

  const icon = pathname === "/" ? "log" : "";

  return (
    <div
      className={
        "header-web" + " " + (pathname === "/" + lodInf?.lodNo ? "w-md" : "")
      }
    >
      {pathname === "/" && (
        <h4
          head-icon={"log"}
          onClick={() => {
            navigate("/" + lodInf?.lodNo);
          }}
        />
      )}
      {pathname !== "/" && (
        <>
          <h4
            head-icon={"log"}
            onClick={() => {
              navigate("/" + lodInf?.lodNo);
            }}
          >
            {lodInf?.lodNm}
          </h4>
          <ul>
            <li
              onClick={() => {
                if (isLogin) {
                  navigate("mypage/resv");
                }
                if (!isLogin && !pathname.includes("login")) {
                  modalControl({
                    isOpen: true,
                    chckBtn: false,
                    styles: "max-w-[700px] ",
                    inner: <LoginModal prevPath={"mypage/resv"} />,
                  });
                }
                if (pathname.includes("login")) {
                  alertControl({
                    isOpen: true,
                    inner: t("alr_login_check_bk"),
                  });
                }
              }}
            >
              <button>{t("lst_hd_rsvt")}</button>
            </li>
            <li>
              <AuthActionBtn />
            </li>
            <li
              hidden={isLogin || pathname.includes("login")}
              onClick={() => {
                if (pathname === "/" + lodInf?.lodNo) {
                  navigate("login", {
                    state: {
                      prevPath: pathname,
                    },
                  });
                }
                if (pathname !== "/" + lodInf?.lodNo) {
                  modalControl({
                    isOpen: true,
                    chckBtn: false,
                    styles: "max-w-[700px] ",
                    inner: <LoginModal />,
                  });
                }
              }}
            >
              {t("lst_hd_lgi")}
            </li>

            {/* 언어선택 */}
            <li>
              <LangChange height={28} />
            </li>
          </ul>
        </>
      )}
    </div>
  );
}
